import useAPI from '@/pages/members/hooks/useAPI';
import { InsuranceProviderRepository } from '@/repositories/members/InsuranceProviderRepository';

import { ONBOARDING_QUERY_KEY_PREFIX } from '../pages/Onboarding/components/Stepper';

export interface InsuranceProviderParams {
  exclude_jurisdiction?: string;
  jurisdiction?: string;
}

export const useInsuranceProviders = ({
  exclude_jurisdiction,
  jurisdiction
}: InsuranceProviderParams) => {
  const insuranceProviderRepository = InsuranceProviderRepository();

  return useAPI({
    queryKey: [
      ONBOARDING_QUERY_KEY_PREFIX,
      'insuranceProviders',
      exclude_jurisdiction,
      jurisdiction
    ],
    queryFn: () => insuranceProviderRepository.list({ exclude_jurisdiction, jurisdiction }),
    refetchOnWindowFocus: false
  });
};
